import { FOfferType } from '../../../utils/category';
import { OfferTypeLabel } from '../offer_type';

export const getParamTitleHelper = (offerTypes: FOfferType[], offerType: FOfferType) => {
  const selectedOfferTypes = offerTypes.filter(type => type & offerType);

  return (possibleOfferTypes: FOfferType[]): string => {
    const selectedPossibleOfferTypes = possibleOfferTypes
      .map(possibleOfferType => {
        let label = offerType & possibleOfferType ? OfferTypeLabel[possibleOfferType] : '';

        if (possibleOfferType !== FOfferType.FreeAppointmentObject) {
          label = label.toLowerCase();
        }

        return label;
      })
      .filter(item => item !== '');

    return selectedOfferTypes.length > 1 ? ` (${selectedPossibleOfferTypes.join(', ')})` : '';
  };
};
